import './css/index.css';
import { array, bool, func } from 'prop-types';
import React from 'react';

const toggleClass = ( status ) => {

    return status ? 'toggle-on' : 'toggle-off';

};

const Toggle = ( { active, setActive, labels, subLabels } ) => {

    const handleClick = () => {

        setActive( !active );

    };

    return (

        <div className="toggle-button" onClick={ handleClick }>

            <div className="toggle-container">

                <div className={ `toggle-btn ${ toggleClass( !active ) }` }>
                    { labels[ 0 ] }
                    <span className="subtext">{ subLabels[ 0 ] }</span>
                </div>

                <div className={ `toggle-btn ${ toggleClass( active ) }` }>
                    { labels[ 1 ] }
                    <span className="subtext">{ subLabels[ 1 ] }</span>
                </div>

            </div>

        </div>

    );

};

Toggle.propTypes = {
    active: bool,
    setActive: func,
    labels: array,
    subLabels: array,
};

export { Toggle };
